module.exports = {
  // apiUrl: 'http://localhost:3333/api/'
  // apiUrl: 'https://mepha-api-master-256190687603.europe-west1.run.app/api/'
  apiUrl: 'https://mepha-scan.com/api/'
}



//////////////////
// WEBPACK FOOTER
// ./env.js
// module id = 77eN
// module chunks = 14